module.exports = __webpack_public_path__ + "img/malaysia_bank.bd2c24a6.png";